/**
 * A session's lifecycle as a `.tag` pill. Neutral by design: an active session gets a
 * small ink dot, the one thing on the page that says "this is still happening", and a
 * finished one is grey — completion is a state, not a verdict, so it wears no green.
 */

import type { AdminSessionDetail } from "../../api/types";
import { cn } from "../../lib/cn";

type Status = AdminSessionDetail["status"];

const CLASS: Record<Status, string> = {
  active: "tag-active",
  completed: "tag-completed",
  abandoned: "tag-abandoned",
};

const LABEL: Record<Status, string> = {
  active: "Active",
  completed: "Completed",
  abandoned: "Abandoned",
};

export default function StatusTag({ status, className }: { status: Status; className?: string }) {
  return (
    <span className={cn("tag", CLASS[status], className)}>
      {status === "active" ? (
        <span aria-hidden className="h-1.5 w-1.5 shrink-0 rounded-pill bg-ink-strong" />
      ) : null}
      {LABEL[status]}
    </span>
  );
}
